import { Icon as ChakraIcon } from "@chakra-ui/react";
import { icons } from "./iconsList";
import "./icon.css";
import { IconProps } from "./Icon.types";

const Icon = ({ name, variant, ...rest }: IconProps) => (
  <ChakraIcon
    viewBox="0 0 24 24"
    {...rest}
    data-path-type={variant}
    data-icon="icon"
  >
    {icons[name]}
  </ChakraIcon>
);

export default Icon;
